export const API_DATE_FORMAT = 'YYYY-MM-DD'
